export default __webpack_public_path__ + "locales/el-GR/RoomLogoCover.json?hash=d8574ad71390ca98d854e9a1aa1ea2da";